<template>
  <div class="app-container">
    <div class="warpper">
      <el-form ref="searchForm" :inline="true" :model="searchCondition">
        <el-form-item label="姓名">
          <el-input
            v-model="searchCondition.consigneeName"
            placeholder="姓名"
            clearable
          />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            v-model="searchCondition.consigneeMobile"
            placeholder="手机号"
            clearable
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchList">查询</el-button>
          <el-button @click="resetField()">重置</el-button>
        </el-form-item>
      </el-form>
      <el-tabs v-model="searchCondition.status" @tab-click="changeTabs">
        <el-tab-pane
          :label="`全部（${
            countNum.countStatus1 +
            countNum.countStatus2 +
            countNum.countStatus3 +
            countNum.countStatus4
          }）`"
          name="0"
        />
        <el-tab-pane
          :label="`待支付（${countNum.countStatus1}）`"
          name="12701"
        />
        <el-tab-pane
          :label="`待发货（${countNum.countStatus2}）`"
          name="12702"
        />
        <el-tab-pane
          :label="`待收货（${countNum.countStatus3}）`"
          name="12703"
        />
        <el-tab-pane
          :label="`已完成（${countNum.countStatus4}）`"
          name="12704"
        />
      </el-tabs>
      <el-table
        v-loading="tableLoading"
        :data="tableData"
        style="width: 100%"
        border
      >
        <el-table-column prop="orderNo" label="订单号" align="center" />
        <el-table-column prop="consigneeName" label="收件人" align="center" />
        <el-table-column
          prop="consigneeMobile"
          label="联系方式"
          align="center"
        />
        <el-table-column
          prop="consigneeAddress"
          label="收货地址"
          align="center"
          width="130"
        >
          <template slot-scope="{ row }">
            {{ row.consigneeProvince + row.consigneeCity + row.consigneeDistrict + row.consigneeAddress }}
          </template>
        </el-table-column>
        <el-table-column
          prop="orderDrugsDrugInfo"
          label="药品信息"
          align="center"
        />
        <el-table-column prop="drugNum" label="药品数量" align="center" />
        <el-table-column prop="paidPrice" label="药品金额" align="center" />
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="{ row }">
            {{ DRUG_ORDER_STATUS[row.status] }}
          </template>
        </el-table-column>
        <el-table-column prop="gmtCreate" label="创建时间" align="center" />
        <el-table-column fixed="right" label="操作" align="center">
          <template slot-scope="{ row }">
            <el-button
              v-if="row.status === 12702"
              type="text"
              size="small"
              @click="drugFormClick(row)"
              >发药</el-button
            >
            <el-button type="text" size="small" @click="onPrescription(row)"
              >处方</el-button
            >
            <el-button type="text" size="small" @click="onDetail(row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          :current-page="searchCondition.currentPage"
          :page-size="searchCondition.pageSize"
          :total="totalCount"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100]"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
      <!-- 发药 -->
      <el-dialog title="发药页面" :visible.sync="drugFormFlag">
        <SendDrug
          v-if="drugFormFlag"
          :is-edit="isEdit"
          :item-list="itemList"
          @closeForm="closeForm"
          @refresh="resetField"
        />
      </el-dialog>
      <!-- 处方详情 -->
      <el-dialog title="处方详情" :visible.sync="prescriptionFlag">
        <div class="mt-2">
          <span v-html="prescriptionHtml"></span></div
      ></el-dialog>
      <!-- 药品详情 -->
      <el-dialog title="订单详情" :visible.sync="detailFlag">
        <DrugForm
          v-if="detailFlag"
          :is-edit="isEdit"
          :item-list="itemList"
          @closeForm="closeForm"
          @refresh="resetField"
        />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  pharmacistOrderList,
  pharmacistOrderNum,
  getPrescriptionForm,
} from "@/api/doctor.js";
import SendDrug from "./components/sendDrug";
import DrugForm from "./components/form";
import { DRUG_ORDER_STATUS } from "@/utils/eum";

export default {
  name: "DrugList",
  components: { SendDrug, DrugForm },
  data() {
    return {
      DRUG_ORDER_STATUS,
      tableLoading: false,
      drugFormFlag: false, // 发药
      prescriptionFlag: false, // 处方
      detailFlag: false, // 详情
      searchCondition: {
        currentPage: 1,
        pageSize: 10,
        consigneeName: "",
        consigneeMobile: "",
        status: 0,
      },
      totalCount: 0,
      tableData: [],
      isEdit: 0,
      itemList: [],
      countNum: {
        countStatus1: 0,
        countStatus2: 0,
        countStatus3: 0,
        countStatus4: 0,
      },
      prescriptionHtml: "",
    };
  },
  created() {
    this.getList();
    this.getListNum();
  },
  methods: {
    async getList() {
      this.tableLoading = true;
      const res = await pharmacistOrderList(this.searchCondition);
      this.tableData = res.data.dataList || [];
      this.totalCount = parseInt(res.data.totalCount);
      this.tableLoading = false;
    },
    async getListNum() {
      this.tableLoading = true;
      const resNum = await pharmacistOrderNum(this.searchCondition);
      this.countNum = resNum.data;
      this.tableLoading = false;
    },
    handleCurrentChange(val) {
      this.searchCondition.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.searchCondition.pageSize = val;
      this.getList();
    },
    // 查询
    searchList() {
      this.getList();
      this.getListNum();
    },
    // 重置
    resetField() {
      this.searchCondition.consigneeName = "";
      this.searchCondition.consigneeMobile = "";
      this.drugFormFlag = false;
      this.prescriptionFlag = false;
      this.detailFlag = false;
      this.getList();
    },
    // 发药
    drugFormClick(item) {
      this.drugFormFlag = true;
      this.isEdit = 1;
      this.itemList = item;
    },
    // 处方
    onPrescription(item) {
      this.prescriptionFlag = true;
      this.itemList = item;
      this.getPrescription();
    },
    // 详情
    onDetail(item) {
      this.detailFlag = true;
      this.isEdit = 0;
      this.itemList = item;
    },
    // 关闭弹窗通知
    closeForm() {
      this.drugFormFlag = false;
      this.prescriptionFlag = false;
      this.detailFlag = false;
    },
    // 切换tab
    changeTabs(tab, event) {
      this.getList();
    },
    /**
     * 获取处方单html
     */
    async getPrescription() {
      const params = {
        recipeId: this.itemList.recipeId,
      };

      const res = await getPrescriptionForm(params);
      if (res.code == 1) {
        this.prescriptionHtml = res.data;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.app-container {
  height: 100%;
  min-width: 1200px;
  margin-top: 15px;

  .warpper {
    width: 95%;
    margin: auto;
  }
}
.el-table__body /deep/ .el-table__empty-text {
  width: 25% !important;
}
.block {
  margin-top: 10px;
}
.el-tabs {
  margin-bottom: 0;
}
</style>
